function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Children, useState } from 'react';
import ChevronRight from '@domain-group/fe-co-icon/lib/js/chevron-right';
import ChevronLeft from '@domain-group/fe-co-icon/lib/js/chevron-left';
import useHorizontalSlider from '../../utils/use-horizontal-slider';
import * as styles from './card-row.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var CardRow = _ref => {
  var children = _ref.children,
    id = _ref.id,
    className = _ref.className,
    _ref$hasScrollButtons = _ref.hasScrollButtons,
    hasScrollButtons = _ref$hasScrollButtons === void 0 ? false : _ref$hasScrollButtons;
  var slideHandler = useHorizontalSlider();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    leftScrollButtonVisible = _useState2[0],
    setLeftScrollButtonVisible = _useState2[1];
  var _useState3 = useState(Children.count(children) > 1),
    _useState4 = _slicedToArray(_useState3, 2),
    rightScrollButtonVisible = _useState4[0],
    setRightScrollButtonVisible = _useState4[1];
  return ___EmotionJSX("div", {
    id: id,
    className: className,
    css: styles.cardRow
  }, hasScrollButtons && ___EmotionJSX("button", {
    type: "button",
    css: styles.scrollBtnLeft,
    style: {
      opacity: leftScrollButtonVisible ? 100 : 0
    },
    onClick: () => {
      var _slideHandler$ref$cur;
      (_slideHandler$ref$cur = slideHandler.ref.current) === null || _slideHandler$ref$cur === void 0 ? void 0 : _slideHandler$ref$cur.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    },
    "aria-label": "Scroll Left"
  }, ___EmotionJSX(ChevronLeft, {
    css: styles.scrollButtonIcon,
    size: "custom"
  })), ___EmotionJSX("div", _extends({
    css: styles.items,
    onScroll: evt => {
      if (hasScrollButtons) {
        var target = evt.target;
        setLeftScrollButtonVisible(target.scrollLeft > 10);
        setRightScrollButtonVisible(Children.count(children) > 1 && target.scrollLeft <= target.scrollWidth - target.clientWidth - 10);
      }
    }
  }, slideHandler), children), hasScrollButtons && ___EmotionJSX("button", {
    type: "button",
    css: styles.scrollBtnRight,
    style: {
      opacity: rightScrollButtonVisible ? 100 : 0
    },
    onClick: () => {
      if (slideHandler.ref.current) {
        var scrollWidth = slideHandler.ref.current.scrollWidth - slideHandler.ref.current.clientWidth;
        slideHandler.ref.current.scrollTo({
          left: scrollWidth,
          behavior: 'smooth'
        });
      }
    },
    "aria-label": "Scroll Right"
  }, ___EmotionJSX(ChevronRight, {
    css: styles.scrollButtonIcon,
    size: "custom"
  })));
};
export default CardRow;